module.exports = {"apiKey":"AIzaSyA8els0yPulfAlLHnwqD9MQ0_afUJWg9Q8","authDomain":"auth.maprinter.com","databaseURL":"https://maprinter-f4b78.firebaseio.com","projectId":"maprinter-f4b78","storageBucket":"maprinter-f4b78.appspot.com","messagingSenderId":"137262836911"}


//////////////////
// WEBPACK FOOTER
// ./src/json/firebase.json
// module id = 105
// module chunks = 0